<h1 mat-dialog-title class="dialog-title voice-status" [class.active]="store.isListening()" [class.error]="errorMessage">
    <mat-icon style="color: #0b75c9" [class.listening-icon]="store.isListening()">{{ store.isListening() ? 'mic' : 'mic_off' }}</mat-icon> Selecionar {{ ObjData?.nameClass || 'Item' }}
</h1>
<span class="voice-status" [attr.data-text]="currentMessage" [class.change]="messageChanged">
                {{ currentMessage }}
            </span>
<div mat-dialog-content>
    <!-- CAMPO DE BÚSQUEDA AÑADIDO -->
    <mat-form-field appearance="outline" class="w-100">
        <mat-label>Pesquisar {{ ObjData?.nameClass || 'Item' }}</mat-label>
        <input matInput type="text" [(ngModel)]="searchTerm" placeholder="Digite para filtrar">
        <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    <!-- FIN DEL CAMPO DE BÚSQUEDA -->

    <mat-list-item
            *ngFor="let data of filteredItems; let i = index"
            class="client-item"
            [class.selected]="selectedNumber === (i + 1)"
            (click)="selectData(data.id)">
        <div class="item-content">
            <div class="number-badge">{{ i + 1 }}</div>
            <mat-icon class="client-icon">{{ ObjData.icon }}</mat-icon>
            <div class="client-info">
                <div class="client-name">{{ data.name }}</div>
                <div class="client-id">{{ data.descriptor }}</div>
            </div>
        </div>
    </mat-list-item>

    <div *ngIf="!ObjData.items?.length" class="empty-state">
        <mat-icon>group_off</mat-icon>
        <div>Não há dados para mostrar.</div>
    </div>
</div>
